import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderProvider } from './HeaderContext';
import { CreateMarketChat } from './CreateMarketChat';
import './GenerateMarkets.css';
import './GenerateMarkets.scss';

const GenerateMarkets = () => {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [handleClose]);

  return (
    <div className="gm-overlay gm-root dark">
      <button
        className="gm-close-btn"
        onClick={handleClose}
        aria-label="Close Generate Markets"
        title="Close (Esc)"
      >
        ✕
      </button>

      <HeaderProvider>
        <CreateMarketChat connectWalletModal={null} onClose={handleClose} />
      </HeaderProvider>
    </div>
  );
};

export default GenerateMarkets;
